module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      banner: true, quick: _vm.quick
    }
  }, [_c('h1', [_vm._v("LIFTKORT OCH KEYCARD")]), _vm._v(" "), (_vm.SITE_CONFIG.site === 'branas' || _vm.SITE_CONFIG.site === 'branas') ? _c('img', {
    staticClass: "badge",
    attrs: {
      "src": "https://static.booking.branasgruppen.se/static/img/badge-lifkort.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "info center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Liftkort och säsongskort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.day_online && !_vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Liftkort")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('h2', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Säsongskort")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("Ladda och köp")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && !_vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [(!_vm.SITE_CONFIG.skipass.day_online && _vm.SITE_CONFIG.skipass.season_online) ? _c('span', [_vm._v("Köp säsongskort")]) : _c('span', [_vm._v("Köp liftkort")])]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.buy_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open('SkiPassPickDateKeycard')
      }
    }
  }, [_vm._v("Köp laddningsbart liftkort")]) : _vm._e(), _vm._v(" "), (!_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.open()
      }
    }
  }, [_vm._v("Ladda liftkort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && !_vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToLoading()
      }
    }
  }, [_vm._v("Ladda liftkort")]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.buy_enabled && _vm.SITE_CONFIG.skipass.load_enabled) ? _c('button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.goToLoading()
      }
    }
  }, [_vm._v("Bara ladda")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "info-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageContent)
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Slipp köer och åk direkt ut i backen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-433108ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiPass/SkiPassPage.vue
// module id = 944
// module chunks = 0